import { Route, Routes } from 'react-router-dom'
import { ContatoTemplate, MainTemplate, QuemSomosTemplate, ServicosTemplate } from './components'

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainTemplate />} />
      <Route path="/servicos" element={<ServicosTemplate />} />
      <Route path="/quem-somos" element={<QuemSomosTemplate />} />
      <Route path="/contato" element={<ContatoTemplate />} />
    </Routes>
  )
}

export default App
